module.exports = __webpack_public_path__ + "media/images/menu/piscis_austrinus-fbfacd3056190b02ca4d0717f2108437.jpg";